<template lang="pug">

</template>

<script>
import { getTokenAndLocation } from '../../utils/index';
import { getForestAccountStatus } from '../../api/ant-forest';

export default {
  mounted() {
    this.getBasic();
  },
  methods: {
    async getBasic() {
      const { token, cityCode, adCode } = await getTokenAndLocation();
      getForestAccountStatus({
        token, cityCode, adCode, pointType: 2,
      }).then((v) => {
        if (v && v.data) {
          const { antStatus } = v.data;

          const path = (antStatus === 1 || antStatus === 3) ? '/ant-forest/record' : '/ant-forest/auth';
          this.$router.replace({
            path,
          });
        }
      });
    },
  },
};
</script>
